import type { ComponentProps } from 'react';

const ExclamationTriangle = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_192_68711)">
        <g clip-path="url(#clip1_192_68711)">
          <path
            d="M31.9953 21.598C32.1016 21.4188 32.2941 21.3125 32.5 21.3125C32.7059 21.3125 32.8984 21.4188 33.0047 21.598L46.173 43.2266C46.266 43.3793 46.3125 43.552 46.3125 43.7246C46.3125 44.2559 45.8809 44.6875 45.3496 44.6875H19.6504C19.1191 44.6875 18.6875 44.2559 18.6875 43.7246C18.6875 43.5453 18.734 43.3727 18.827 43.2266L31.9953 21.598ZM29.2727 19.9379L16.1043 41.5664C15.7059 42.2172 15.5 42.9609 15.5 43.7246C15.5 46.0156 17.3594 47.875 19.6504 47.875H45.3496C47.6406 47.875 49.5 46.0156 49.5 43.7246C49.5 42.9609 49.2875 42.2172 48.8957 41.5664L35.7273 19.9379C35.0434 18.8156 33.8215 18.125 32.5 18.125C31.1785 18.125 29.9566 18.8156 29.2727 19.9379ZM34.625 40.4375C34.625 39.8739 34.4011 39.3334 34.0026 38.9349C33.6041 38.5364 33.0636 38.3125 32.5 38.3125C31.9364 38.3125 31.3959 38.5364 30.9974 38.9349C30.5989 39.3334 30.375 39.8739 30.375 40.4375C30.375 41.0011 30.5989 41.5416 30.9974 41.9401C31.3959 42.3386 31.9364 42.5625 32.5 42.5625C33.0636 42.5625 33.6041 42.3386 34.0026 41.9401C34.4011 41.5416 34.625 41.0011 34.625 40.4375ZM34.0938 28.2188C34.0938 27.3355 33.3832 26.625 32.5 26.625C31.6168 26.625 30.9062 27.3355 30.9062 28.2188V34.5938C30.9062 35.477 31.6168 36.1875 32.5 36.1875C33.3832 36.1875 34.0938 35.477 34.0938 34.5938V28.2188Z"
            fill="#C5CCD6"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_192_68711">
          <rect
            width="64"
            height="64"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
        <clipPath id="clip1_192_68711">
          <rect
            width="34"
            height="34"
            fill="white"
            transform="translate(15.5 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExclamationTriangle;
